/**
 * Normalize phone-like search input for admin user/rent lookup.
 * Strips spaces/dashes; RU 8XXXXXXXXXX → +7XXXXXXXXXX; 9XXXXXXXXX (10) → +7…
 */
export function normalizePhoneSearchQuery(input) {
  const raw = String(input ?? '').trim();
  if (!raw) return '';

  const digits = raw.replace(/\D/g, '');
  if (!digits) return raw;

  let normalized = digits;
  if (normalized.length === 11 && normalized.startsWith('8')) {
    normalized = `7${normalized.slice(1)}`;
  } else if (normalized.length === 10 && normalized.startsWith('9')) {
    normalized = `7${normalized}`;
  }

  if (normalized.length >= 10 && normalized.length <= 15) {
    return `+${normalized}`;
  }

  return raw.replace(/\s+/g, '');
}

/** Classify Users search: phone / email / Mongo id. */
export function classifyUserSearchQuery(input) {
  const str = String(input ?? '').trim();
  if (!str) return { type: 'empty' };
  if (/^[0-9a-fA-F]{24}$/.test(str)) return { type: 'id', value: str };
  if (str.includes('@')) return { type: 'email', value: str };

  const phone = normalizePhoneSearchQuery(str);
  if (phone.startsWith('+') && phone.length >= 11) {
    return { type: 'phone', value: phone };
  }

  const digitsOnly = str.replace(/\D/g, '');
  if (digitsOnly.length >= 10 && digitsOnly.length <= 15) {
    return { type: 'phone', value: normalizePhoneSearchQuery(digitsOnly) };
  }

  return { type: 'unknown', value: str };
}
